/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateServiceproviderRequest
 */
export interface UpdateServiceproviderRequest {
    /**
     * Display name of the serviceprovider organization (shown to clients).
     */
    companyName: string;
    /**
     * Contact email address shown to clients.
     */
    email?: string;
    /**
     * Contact phone number shown to clients.
     */
    phone?: string;
}

/**
 * Check if a given object implements the UpdateServiceproviderRequest interface.
 */
export function instanceOfUpdateServiceproviderRequest(value: object): value is UpdateServiceproviderRequest {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function UpdateServiceproviderRequestFromJSON(json: any): UpdateServiceproviderRequest {
    return UpdateServiceproviderRequestFromJSONTyped(json, false);
}

export function UpdateServiceproviderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateServiceproviderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function UpdateServiceproviderRequestToJSON(json: any): UpdateServiceproviderRequest {
    return UpdateServiceproviderRequestToJSONTyped(json, false);
}

export function UpdateServiceproviderRequestToJSONTyped(value?: UpdateServiceproviderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'email': value['email'],
        'phone': value['phone'],
    };
}

